import React from "react";
import { useTranslation } from "react-i18next";

const EmptyState = ({ message, cta, onCtaClick }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center bg-white rounded-md">
      <p className="mb-4 text-lg text-gray-600">{t(message)}</p>
      {cta && (
        <button
          onClick={onCtaClick}
          className="px-4 py-2 text-white rounded-md bg-blue-600 hover:bg-taction-dark focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-taction font-bold"
        >
          {t(cta)}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
